import { useScrollPosition } from '@/hooks/useScrollPosition'
import { useSmoothScroll } from '@/hooks/useSmoothScroll'
import { CONFIG } from '@/config/constants'

export function PageTopButton() {
  const { y } = useScrollPosition()
  const { scrollToTop } = useSmoothScroll()

  const isVisible = y > CONFIG.PAGE_TOP.showThreshold

  return (
    <button
      className={`page-top-btn ${isVisible ? 'visible' : ''}`}
      onClick={scrollToTop}
      aria-label="ページトップに戻る"
    >
      <div className="page-top-arrow">
        <div className="chevron-up-left"></div>
        <div className="chevron-up-right"></div>
      </div>
    </button>
  )
}
